import { apiClient } from '@slot-nx/core'
import { IOpBetDetailApi } from './IOpBetDetailApi'
import { gameConfig } from '../../../config'
import { BetDetailResponse } from '../models/BetDetailResponse'

export const opBetDetailApi: IOpBetDetailApi = {
  async getOpBetDetail(payload: string, time: string): Promise<BetDetailResponse> {
    const res = await apiClient.get<BetDetailResponse>(`${gameConfig.name}/operator/betdetail`, {
      params: {
        payload,
        time,
      },
    })
    return res.data
  },
}
